var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side_content"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,staticClass:"side_item",class:{ active: _vm.isSelected(index) },on:{"click":function($event){return _vm.activeTab(index)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }